<template>
  <div>
    <div class="block_progress form_wrapper">
      <div class="form_header">
                <div class="form_header_name">流程进度</div>
                <div class="form_header_remarks"></div>
              </div>
      <div class="stepsblock">
        <el-steps
          :active="data.process"
          :space="data.wfStatus == 2 && data.auditState != 0 ? '15%' : '100%'"
          align-center
          :center="true"
        >
          <el-step
            title="新增付款"
            icon="el-icon-circle-check"
            :description="data.createTime"
          ></el-step>
          <el-step
            :title="
              data.wfCreateDate != ''
                ? '提交审批' + '(流水号:' + data.flowId + ')'
                : '提交审批'
            "
            :description="data.wfCreateDate ? data.wfCreateDate : ''"
          >
            <template slot="icon"> </template>
          </el-step>
          <el-step
            title="审批中"
            :description="data.wfCreateDate != '' ? data.wfCreateDate : ''"
          >
          </el-step>
          <el-step
            v-if="data.wfStatus != 4"
            :title="
              data.wfStatus == 2 && data.auditState == 0
                ? '审批通过'
                : '审批结果'
            "
            :description="data.wfUpdateDate != '' ? data.wfUpdateDate : ''"
          ></el-step>
          <el-step
            v-if="data.wfStatus == 4"
            title="跳过审批"
            :description="data.submitTime != '' ? data.submitTime : ''"
          ></el-step>
          <el-step
            v-if="data.wfStatus >= 2 && data.auditState != 0"
            title="提交审核"
            :description="data.submitTime != '' ? data.submitTime : ''"
          ></el-step>

          <el-step
            title="审核中"
            v-if="data.wfStatus >= 2 && data.auditState != 0"
            :description="data.auditBeginTime != '' ? data.auditBeginTime : ''"
          ></el-step>
          <el-step
            v-if="data.wfStatus >= 2 && data.auditState != 0"
            :title="
              data.wfStatus == 2 && data.auditState == 2
                ? '审核通过'
                : '审核结果'
            "
            :description="data.auditTime != '' ? data.auditTime : '等待审核'"
          >
            <template slot="title">
              {{
                data.wfStatus >= 2 && data.auditState == 2
                  ? "审核通过"
                  : "审核结果"
              }}
              <span v-if="data.auditLog"
                ><i
                  class="el-icon-warning-outline warningblock"
                  @click="warningblock"
                ></i
              ></span>
            </template>
          </el-step>
        </el-steps>
      </div>
    </div>

    <div class="bankmanageDetail">
      <div class="bankdetail_title">
        <div class="banktail_">
     
          <div>
            <div class="form_wrapper">
              <div class="form_header">
                <div class="form_header_name">付款信息</div>
                <div class="form_header_remarks"></div>
              </div>
              <div class="form_content">
                <div class="label_name">基础信息</div>
                <div class=" informations">
                  <el-row :gutter="20">
                    <el-col :span="8"> 
                      <div class="grid_content">
                        <span class="banktitle_content_">投放名称:</span>
                       <div class='banktitle_'> {{ data.paymentTitle }}</div>
                      </div>
                      <div class="grid_content">
                        <span class="banktitle_content_">项目名称:</span>
                        <div class='banktitle_'>{{ data.contract.projectName }}</div>
                      </div>
                      <div class="grid_content">
                        <span class="banktitle_content_">客户经理:</span>
                        <div class='banktitle_'> {{ data.contract.managerName }}</div>
                      </div>
                    </el-col>
                    <el-col :span="9">
                      <div class="grid_content">
                        <span class="banktitle_content_">款项类型:</span>
                        <div class='banktitle_'>{{ data.paymentType ==1?"转贷本金":data.paymentType==2?'退费':data.paymentType==3?'罚息':''}}</div> 
                      </div>
                      <div class="grid_content">
                        <span class="banktitle_content_"> 合同名称:</span>
                        <div class='banktitle_'>{{ data.contract.contractName }}</div> 
                      </div>
                      <div class="grid_content">
                        <span class="banktitle_content_">申请部门:</span>
                        <div class='banktitle_'> {{ data.contract.deptName }}</div>
                      </div>
                    </el-col>
                    <el-col :span="7"> 
                      <div class="grid_content">
                        <span class="banktitle_content_">客户名称:</span>
                        <div class='banktitle_'>  {{ data.contract.custName }}</div>
                      </div>
                      <div class="grid_content">
                        <span class="banktitle_content_">付款主体:</span>
                        <div class='banktitle_'>  {{ data.payEntityName }}</div>
                      </div>
                      <div class="grid_content">
                        <span class="banktitle_content_">预计付款日期:</span>
                        <div class='banktitle_'>  {{ data.planDate }}</div>
                      </div>
                    </el-col>
                  </el-row>
                </div>
             
                <div class="label_name">财务信息</div>
                <div class="informations">
                  <el-row :gutter="20">
                    <el-col :span="8">
                      <div class="grid_content">
                        <span class="banktitle_content_">付款金额:</span>
                        <div class='banktitle_'>  {{ getMoney(data.paymentAmount) }}</div>
                      </div>
                      <div class="grid_content">
                        <span class="banktitle_content_">付款人开户行:</span>
                        <div class='banktitle_'>  {{ data.payOpeningBank }}</div>
                      </div>
                      <div class="grid_content">
                        <span class="banktitle_content_">收款人开户行:</span>
                        <div class='banktitle_'> {{ data.collectOpeningBank }}</div>
                      </div>
                  
                    </el-col>
                    <el-col :span="8">
                      <div class="grid_content">
                        <span class="banktitle_content_">大写金额:</span>
                        <div class='banktitle_'> {{ data.paymentAmountStr }}</div> 
                      </div>
                      <div class="grid_content">
                        <span class="banktitle_content_"> 付款人户名:</span>
                        <div class='banktitle_'>   {{ data.payAccountName }}</div> 
                      </div>
                      <div class="grid_content">
                        <span class="banktitle_content_">收款人户名:</span>
                        <div class='banktitle_'>  {{ data.collectBankAccount }}</div> 
                      </div>
                    </el-col>
                    <el-col :span="8">
                    
                      <div class="grid_content">
                        <span class="banktitle_content_">付款人账号:</span>
                        <div class='banktitle_'>{{ data.payBankAccount }}</div> 
                      </div>
                      <div class="grid_content">
                        <span class="banktitle_content_">收款人账号:</span>
                        <div class='banktitle_'>{{ data.collectAccountName }}</div> 
                      </div>
                    </el-col>
                  </el-row>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <Dialog :data="data" ref="dialogpass" />

  </div>
</template>

<script>
import Dialog from "./dialog";
export default {
  name: "",
  data() {
    return {
      dialogpassVisible: false
    };
  },

  props: {
    auditState: Boolean,
    bankid: String,
    data: JSON
  },
  components: {
 
    Dialog
  },
  created() {},

  computed: {},
  methods: {
    warningblock() {
      this.$refs.dialogpass.showblock();
    }
  }
};
</script>

<style lang="scss" scoped>
.block_progress {
  margin-top: 15px;
  border: 1px solid #ddd;
  border-radius: 10px;
  .progress_title {
    line-height: 45px;
    font-weight: 500;
    font-size: 15px;
    background-color: rgba(249, 249, 249, 1);
    text-indent: 15px;
    border-top-left-radius: 10px;
    border-top-right-radius: 10px;
  }
  .stepsblock {
    padding: 25px 15px;
  }
}
.stepsblock .el-step__title.is-process {
  font-weight: 500;
}
.stepsblock .el-step__head.is-process,
.stepsblock .el-step__title.is-process,
.stepsblock .el-step__description.is-process {
  color: #c0c4cc;
  border-color: #c0c4cc;
  font-weight: 500;
}
.stepsblock .el-step.is-center .el-step__description {
  padding: 0;
}
.stepsblock .el-step__title {
  font-size: 14px;
}


.form_wrapper {
  height: 100%;
  margin: 0;
  box-sizing: border-box;
  border-width: 1px;
  border-style: solid;
  border-color: rgba(233, 233, 233, 1);
  border-radius: 10px;
  background-color: #fff;

  .form_header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    border-width: 0px;
    height: 60px;
    background-color: rgba(249, 249, 249, 1);
    padding: 0 20px;
    border-top-left-radius: 10px;
    border-top-right-radius: 10px;
    border-bottom: 1px rgba(233, 233, 233, 1) solid;

    .form_header_name {
      font-weight: 700;
      color: #333;
      font-size: 16px;
    }
    .form_header_remarks {
      color: #999999;
      font-size: 13px;
      .red_color {
        color: #ff3b30;
      }
    }
  }
  .form_content {
    padding: 20px 50px;
  }
}
.label_name {
  font-weight: 900;
  color: #666666;
  position: relative;
  margin: 30px 0;
  &::after {
    content: "";
    position: absolute;
    top: 50%;
    left: -15px;
    transform: translate(0, -50%);
    height: 18px;
    width: 6px;
    background-color: #409eff;
  }
}
  .grid_content{
  display: flex;
  flex-direction: row;
  margin:10px 0

}
.banktitle_content_{
  display: inline-block;
    font-weight: 500;
    flex:3;
    text-align: right;
 
  }
  
  .banktitle_{
    flex:5;
      text-align: left;
    margin-left: 10px;
}
</style>
